import { schema } from 'normalizr';
import { createAction } from 'redux-api-middleware';
import { handleResponse, handleError } from '../utils';

export const FETCH_KEYWORDS_REQUEST = 'FETCH_KEYWORDS_REQUEST';
export const FETCH_KEYWORDS_SUCCESS = 'FETCH_KEYWORDS_SUCCESS';
export const FETCH_KEYWORDS_FAILURE = 'FETCH_KEYWORDS_FAILURE';

export const keywordSchema = new schema.Entity(
  'keywords',
  {},
  {
    idAttribute: 'area',
    processStrategy(keyword) {
      return {
        ...keyword,
      };
    },
  },
);

export const fetchKeywordsByArea = (area, silo) =>
  createAction({
    endpoint: `${window.config.apiUrl}/keywords/${area}?silo=${silo}`,
    method: 'GET',
    types: [
      { type: FETCH_KEYWORDS_REQUEST },
      {
        type: FETCH_KEYWORDS_SUCCESS,
        payload: (action, state, res) => handleResponse([keywordSchema], action, state, res),
      },
      { type: FETCH_KEYWORDS_FAILURE, payload: handleError },
    ],
  });
